import { Directive, ElementRef, OnDestroy, OnInit, Optional, Renderer2, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';

// Drop onto any formControlName/ngModel input, select or textarea to get a
// live checkmark/red-x (Bootstrap's own .is-valid/.is-invalid icon styles,
// already compiled into the bundle) as the user types, instead of only
// after a failed submit. Purely class toggling on the host element — no
// markup changes, so it can't disturb existing layouts.
@Directive({ selector: '[appFieldValidity]' })
export class FieldValidityDirective implements OnInit, OnDestroy {
  private sub: Subscription;

  constructor(
    @Optional() @Self() private ngControl: NgControl,
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2
  ) { }

  ngOnInit(): void {
    if (!this.ngControl || !this.ngControl.control) {
      return;
    }
    const control = this.ngControl.control;
    this.sub = control.statusChanges.subscribe(() => this.applyState());
    this.sub.add(control.valueChanges.subscribe(() => this.applyState()));
    this.applyState();
  }

  private applyState(): void {
    const control = this.ngControl.control;
    const el = this.el.nativeElement;
    this.renderer.removeClass(el, 'is-valid');
    this.renderer.removeClass(el, 'is-invalid');
    if (!control.dirty && !control.touched) {
      return;
    }
    this.renderer.addClass(el, control.invalid ? 'is-invalid' : 'is-valid');
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
